import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import {authSlice} from "../app/modules/Auth/_redux/authSlice";
import {customersSlice} from "../app/modules/CRM/_redux/customers/customersSlice";
import {vehiclesSlice} from "../app/modules/CRM/_redux/vehicles/vehiclesSlice";
import {pitsSlice} from "../app/modules/CRM/_redux/pits/pitsSlice";
import {qualitySlice} from "../app/modules/CRM/_redux/quality/qualitySlice";
import {tripsSlice} from "../app/modules/TripTracking/_redux/trips/tripsSlice";
import {sitesSlice} from "../app/modules/CRM/_redux/sites/sitesSlice";
import {specificationsSlice} from "../app/modules/CRM/_redux/specifications/specificationsSlice";
import { deviceLocationsSlice } from "../app/modules/TripTracking/_redux/deviceLocations/deviceLocationsSlice";
import {metricsSlice} from "../app/modules/Metrics/_redux/metrics/metricsSlice";
import {delayedtripsSlice} from "../app/modules/Metrics/_redux/delayedtrips/delayedtripsSlice";
import {telemetrySlice} from "../app/modules/GPS/_redux/telemetry/telemetrySlice";
export const rootReducer = combineReducers({
  auth: auth.reducer,
  customers: customersSlice.reducer,
  vehicles: vehiclesSlice.reducer,
  quality: qualitySlice.reducer,
  trips: tripsSlice.reducer,
  deviceLocations: deviceLocationsSlice.reducer,
  sites: sitesSlice.reducer,
  specifications: specificationsSlice.reducer,
  metrics: metricsSlice.reducer,
  telemetry: telemetrySlice.reducer,
  pits:pitsSlice.reducer,
  delayedtrips: delayedtripsSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
